import React from 'react';
import styled from 'styled-components';
import { makeSelectedTariffs } from '../../common/tariffs';
import { useAppDispatch, useAppSelector } from '../../core/hooks';
import { useWidgetId } from '../../core/IdProvider';
import {
  SelectedResource,
  setSelectedResources,
  productSelector,
  selectedTariffsSelector,
  selectedProductTariffHour,
} from '@src/features/product';
import SeatMapSelector from '../SeatMap/SeatMapSelector';
import ProductAdderOngoingCartResume from '@src/components/Product/ProductAdderSummary';
import { getSchedulingFrom } from '@src/common/seatMaps';
import { SimpleDivisor } from '../reusable';
import ProductAdderFooterButtons from './ProductAdderFooterButtons';
import useSelectedProductId from '@src/hooks/useSelectedProductId';

const ProductAdderSeatMap = () => {
  const prodId = useSelectedProductId();

  const widgetId = useWidgetId();
  const tariffsPerTypeSelected = useAppSelector(selectedTariffsSelector(widgetId));
  const selectedHour = useAppSelector(selectedProductTariffHour(widgetId));
  const product = useAppSelector(productSelector(prodId));
  const dispatch = useAppDispatch();

  const selectedTime = selectedHour?.minutes;
  const selectedTariffs = makeSelectedTariffs(tariffsPerTypeSelected, selectedTime ?? null);

  const selectSeatFromMap = (resources: SelectedResource[], isOk: boolean, valueCents: number) => {
    dispatch(setSelectedResources(widgetId, resources, isOk, valueCents));
  };

  const scheduling = getSchedulingFrom(product!, tariffsPerTypeSelected, selectedTime);

  return (
    <ProductAdderSeatMapStyles>
      <ProductAdderOngoingCartResume hideResources={true} />
      <SimpleDivisor margin={20} />
      <SeatMapContainer>
        <SeatMap>
          <SeatMapSelector
            scheduling={scheduling!}
            timeMinutes={selectedHour ?? null}
            selectedTariffs={selectedTariffs}
            onSelectionChange={selectSeatFromMap}
          />
        </SeatMap>
      </SeatMapContainer>
      <ProductAdderFooterButtons />
    </ProductAdderSeatMapStyles>
  );
};

export default ProductAdderSeatMap;

const SeatMap = styled.div`
  width: 100%;
`;

const SeatMapContainer = styled.div`
  display: flex;
  margin-bottom: 1.5vh;
`;
const ProductAdderSeatMapStyles = styled.div``;
